import ChangePassword from "views/ChangePassword";
import Interpreters from "views/interpreters/Interpreters";
import Dashboard from "views/Dashboard";
import Facility from "views/tools/Facility";
import Department from "views/tools/Department";
import ClientType from "views/clients/Accounts";
import ExtensionsList from "views/Extensions";
import { AppointmentRoutes } from "views/Appointment";
import InvoicePayments from "views/InvoicePayments";
import LanguageList from "views/settings/language";
import StateList from "views/settings/state";
import CityList from "views/settings/city";
import LanguageTiersList from "views/settings/languageTiers";
import CreateAccount from "views/clients/accounts/Create";
import UpdateAccount from "views/clients/accounts/Update";
import ClientTemplates from "views/clients/Templates";
import CreateTemplate from "views/clients/templates/Create";
import UpdateTemplate from "views/clients/templates/Update";
import InvoiceAppointmentDetail from "views/InvoicePayments/InvoiceApptDetail";
import PermissionGroups from "views/permissions/Groups";
import PermissionSubUser from "views/permissions/SubUsers";
import UpdateGroup from "views/permissions/groups/Update";
import CreateGroup from "views/permissions/groups/Create";
import PdfView from "views/InvoicePayments/PdfView";
import AllPdfView from "views/AllInvoices/PdfView";
import InvocieList from "views/AllInvoices/AllInvoices";
import InterpreterCreate from "views/interpreters/Create";
import InterpreterUpdate from "views/interpreters/Update";
import IntepreterPayments from "views/Payments/InterpreterPayments";

var routes = [
  {
    path: "",
    title: "Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/",
  },
  {
    path: "appointments",
    title: "Appointments",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <AppointmentRoutes />,
    layout: "",
  },
  {
    path: "billing",
    title: "Billing",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <InvoicePayments />,
    layout: "",
  },
  {
    path: "billings/detail/:id",
    subRoute: true,
    component: <InvoiceAppointmentDetail />,
    layout: "/admin",
  },
  {
    path: "billings/pdf-view/:id",
    subRoute: true,
    component: <PdfView />,
    layout: "/admin",
  },
  {
    path: "invoices",
    title: "Invoices",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <InvocieList />,
    layout: "",
  },
  {
    path: "invoices/pdf-view/:id",
    subRoute: true,
    component: <AllPdfView />,
    layout: "/admin",
  },
  {
    path: "clients/accounts",
    title: "Accounts",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <ClientType />,
    layout: "",
  },
  {
    path: "clients/accounts/create",
    subRoute: true,
    component: <CreateAccount />,
    layout: "/admin",
  },
  {
    path: "clients/accounts/update/:id",
    subRoute: true,
    component: <UpdateAccount />,
    layout: "/admin",
  },
  {
    path: "clients/templates",
    title: "Templates",
    subRoute: true,
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <ClientTemplates />,
    layout: "",
  },
  {
    path: "clients/templates/create",
    subRoute: true,
    component: <CreateTemplate />,
    layout: "/admin",
  },
  {
    path: "clients/templates/update/:id",
    subRoute: true,
    component: <UpdateTemplate />,
    layout: "/admin",
  },
  {
    path: "interpreters",
    title: "Interpreters",
    icon: "/images/calendar-view.png",
    iconActive: "/images/calendar-view.png",
    component: <Interpreters />,
    layout: "/",
  },
  {
    path: "interpreters/create",
    subRoute: true,
    component: <InterpreterCreate />,
    layout: "/admin",
  },
  {
    path: "interpreters/update/:id",
    subRoute: true,
    component: <InterpreterUpdate />,
    layout: "/admin",
  },
  {
    path: "payments",
    title: "Payments",
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <IntepreterPayments />,
    layout: "",
  },
  {
    path: "extensions",
    title: "Extensions",
    icon: "/images/calendar-view.png",
    iconActive: "/images/calendar-view.png",
    component: <ExtensionsList />,
    layout: "/",
  },
  {
    path: "permissions/groups",
    title: "Groups",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <PermissionGroups />,
    layout: "/",
  },
  {
    path: "permissions/groups/create",
    subRoute: true,
    component: <CreateGroup />,
    layout: "/admin",
  },
  {
    path: "permissions/groups/update/:id",
    subRoute: true,
    component: <UpdateGroup />,
    layout: "/admin",
  },

  {
    path: "permissions/sub-users",
    title: "Sub Users",
    subRoute: true,
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <PermissionSubUser />,
    layout: "",
  },
  {
    path: "tools/facility",
    title: "Facility",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <Facility />,
    layout: "/",
  },
  {
    path: "tools/department",
    title: "Department",
    subRoute: true,
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <Department />,
    layout: "",
  },
  {
    path: "settings/city",
    subRoute: true,
    component: <CityList />,
    layout: "/admin",
  },
  {
    path: "settings/state",
    subRoute: true,
    component: <StateList />,
    layout: "/admin",
  },
  {
    path: "settings/language",
    subRoute: true,
    component: <LanguageList />,
    layout: "/admin",
  },
  {
    path: "settings/language-tiers",
    subRoute: true,
    component: <LanguageTiersList />,
    layout: "/admin",
  },
  {
    path: "change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/",
  }
];
export default routes;
